/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { UserContext } from "context";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

export default function data() {
  const { user } = useContext(UserContext);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${apiUrl}/users.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ isAdmin: user.isAdmin }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setUsers(data.users);
      } catch (error) {
        console.error("There was an error fetching the users!", error);
      }
    };

    fetchUsers();
  }, [user]);

  const User = ({ id, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <Link to={`/app/profile/${id}`}>
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="caption">{email}</MDTypography>
        </MDBox>
      </Link>
    </MDBox>
  );

  return {
    columns: [
      {
        Header: "Utenti",
        accessor: "User",
        width: "45%",
        align: "left",
        Cell: ({ row }) => <User id={row.original.id} name={row.original.User} />,
      },
      {
        Header: "Ragione sociale",
        accessor: "CompanyName",
        align: "center",
        Cell: ({ row }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {row.original.CompanyName}
          </MDTypography>
        ),
      },
      {
        Header: "Nome",
        accessor: "Name",
        align: "center",
        Cell: ({ row }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {row.original.Name}
          </MDTypography>
        ),
      },
      {
        Header: "Chiama",
        accessor: "PhoneNumber",
        align: "center",
        Cell: ({ row }) => (
          <MDTypography
            component="a"
            href={`tel:${row.original.PhoneNumber}`}
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {row.original.PhoneNumber}
          </MDTypography>
        ),
      },
    ],

    rows: users.map((user) => ({
      id: user.id,
      User: user.email, // The raw value for filtering
      Name: user.name + " " + user.surname,
      CompanyName: user.company_name,
      PhoneNumber: user.phone_number,
      // Rendering JSX separately in column definition via Cell
    })),
  };
}

